import React from 'react';
import { modules, type ModuleColor } from '../data/content';
const headerBg: Record<ModuleColor, string> = {
  navy: 'bg-navy',
  sono: 'bg-sono',
  emerald: 'bg-emerald',
  purple: 'bg-purple',
  teal: 'bg-teal',
  charcoal: 'bg-charcoal'
};
export function Modules() {
  return <section className="bg-clinical px-3 py-4 sm:px-6" data-id="element-101" data-mp="20vvqqc06ltvh">
      <div className="mx-auto max-w-2xl" data-id="element-102" data-mp="20vdkqnnpw1ad">
        <h2 className="text-center text-[1.2rem] font-extrabold uppercase text-navy sm:text-[1.8rem]" data-id="element-103" data-mp="1465yfdf9xo5e">
          What's included
        </h2>
        <div className="mt-2 space-y-2" data-id="element-104" data-mp="1889dsd52dcvy">
          {modules.map(mod => <article key={mod.number} className="overflow-hidden rounded-md border border-navy/10 bg-white shadow-sm" data-id="element-105" data-mp="1d6b2pep686fc">
              <div className={`flex items-center gap-1.5 px-2.5 py-1.5 ${headerBg[mod.color]}`} data-id="element-106" data-mp="1i3b2x8zcaeyj">
                <span className="text-[0.8rem] leading-none" aria-hidden="true" data-id="element-107" data-mp="2oo3xgz3g2olp">
                  ✅
                </span>
                <h3 className="font-body text-[0.7rem] font-extrabold uppercase leading-tight tracking-wide text-white sm:text-[0.88rem]" data-id="element-108" data-mp="1vl2x7q5vmoa">
                  Module {mod.number} — {mod.title}
                </h3>
              </div>
              <div className="px-2.5 py-2" data-id="element-109" data-mp="3oyheznp98wq1">
                <p className="text-[0.78rem] leading-[1.35] sm:text-[0.92rem]" data-id="element-110" data-mp="3k0obx3j90itz">
                  {mod.body}
                </p>
                <p className="mt-1 text-[0.68rem] font-bold uppercase tracking-wide text-teal sm:text-[0.8rem]" data-id="element-111" data-mp="3f1uwv6obcjrp">
                  {mod.steps}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}